
const resolveCriterionGraderType = (criterion = {}) => {
    if (criterion.graderType === 'ExactMatch' || criterion.grader_type === 'ExactMatch') {
      return 'ExactMatch';
    }
    if (criterion.graderType === 'llm-judge' || criterion.grader_type === 'llm-judge') {
      return 'llm-judge';
    }
    if (criterion.type === 'exact' || criterion.type === 'exact_match') {
      return 'ExactMatch';
    }
    return 'llm-judge';
  };

export function mapDatasetToState(dataset) {
    if (!dataset?.tasks) return [];

    const answersMap = new Map();
    if (dataset.answers && Array.isArray(dataset.answers)) {
      dataset.answers.forEach(ans => {
        if (ans.task_id) answersMap.set(ans.task_id, ans);
      });
    }
  
    return dataset.tasks.map(task => {
      const answerData = answersMap.get(task.task_id);
      
      const references = [];
      const seenReferenceNames = new Set();

      const pushReferenceFromName = (filename) => {
        if (typeof filename !== 'string') return;
        const trimmed = filename.trim();
        if (!trimmed || seenReferenceNames.has(trimmed)) return;
        seenReferenceNames.add(trimmed);
        references.push({
          id: crypto.randomUUID(),
          filename: trimmed,
          mimeType: '',
          size: 0,
          url: '',
          file: null
        });
      };

      const taskReferenceFile = task.reference_file;
      if (Array.isArray(taskReferenceFile)) {
        taskReferenceFile.forEach(pushReferenceFromName);
      } else {
        pushReferenceFromName(taskReferenceFile);
      }

      const answerReferenceFile = answerData?.reference_file;
      if (Array.isArray(answerReferenceFile)) {
        answerReferenceFile.forEach(pushReferenceFromName);
      } else {
        pushReferenceFromName(answerReferenceFile);
      }
  
      if (answerData?.references?.length) {
        answerData.references.forEach(ref => {
          const filename = ref.filename || ref.name || 'Unknown';
          if (seenReferenceNames.has(filename)) return;
          seenReferenceNames.add(filename);
          references.push({
            id: crypto.randomUUID(),
            filename,
            mimeType: ref.mimeType || ref.mime_type || '',
            size: ref.size || 0,
            url: ref.url || '',
            file: null
          });
        });
      }
  
      const criteria = (answerData?.criteria || []).map(criterion => ({
        ...criterion,
        graderType: resolveCriterionGraderType(criterion)
      }));

      const taskMetadata = task.metadata || {};
      const answerMetadata = answerData?.metadata || {};
      const mergedMetadata = {
        ...answerMetadata,
        ...taskMetadata,
      };

      return {
        id: crypto.randomUUID(),
        originalTaskId: task.task_id,
        prompt: task.task_prompt || '',
        answer: answerData?.answer || '',
        references: references,
        tools: answerData?.tools || [],
        criteria: criteria,
        metadata: {
          ...mergedMetadata,
          difficulty: taskMetadata.difficulty || answerMetadata.difficulty || 'medium',
          category: taskMetadata.category || answerMetadata.category || '',
          tags: taskMetadata.tags || answerMetadata.tags || [],
          environment_profile: taskMetadata.environment_profile ?? answerMetadata.environment_profile ?? null,
          expert_time_estimate_min: taskMetadata.expert_time_estimate_min || answerMetadata.expert_time_estimate_min || null,
          junior_time_estimate_min: taskMetadata.junior_time_estimate_min || answerMetadata.junior_time_estimate_min || null,
        },
        environment: {
          base_image: task.environment?.base_image || answerData?.environment?.base_image || 'ubuntu:24.04',
          system_packages: task.environment?.system_packages || answerData?.environment?.system_packages || [],
          python_packages: task.environment?.python_packages || answerData?.environment?.python_packages || [],
          dockerfile: task.environment?.dockerfile || answerData?.environment?.dockerfile || '',
          resources: {
            cpus: task.environment?.resources?.cpus || answerData?.environment?.resources?.cpus || 1,
            memory_mb: task.environment?.resources?.memory_mb || answerData?.environment?.resources?.memory_mb || 2048,
            storage_mb: task.environment?.resources?.storage_mb || answerData?.environment?.resources?.storage_mb || 10240,
            gpus: task.environment?.resources?.gpus ?? answerData?.environment?.resources?.gpus ?? 0,
          },
          timeouts: {
            agent_sec: task.environment?.timeouts?.agent_sec || answerData?.environment?.timeouts?.agent_sec || 900,
            verifier_sec: task.environment?.timeouts?.verifier_sec || answerData?.environment?.timeouts?.verifier_sec || 900,
            build_sec: task.environment?.timeouts?.build_sec || answerData?.environment?.timeouts?.build_sec || 600,
          },
        },
        passThreshold: answerData?.passThreshold ?? 70
      };
    });
  }
  
  export function mapTasksToPayload(tasks) {
    return tasks.map(task => {
      const criteria = (task.criteria || []).map(criterion => {
        const { graderType, grader_type, type, ...rest } = criterion || {};
        return {
          ...rest,
          grader_type: resolveCriterionGraderType({ graderType, grader_type, type })
        };
      });

      return {
        task_id: task.id,
        answer: task.answer,
        reference_file: task.references.length > 0 ? task.references[0].filename : null,
        tools: task.tools || [],
        criteria: criteria,
        metadata: task.metadata || {},
        environment: task.environment || {},
      };
    });
  }
